import pickBy from 'lodash-es/pickBy';
import union from 'lodash-es/union';
import endsWith from 'lodash-es/endsWith';

import {
    SET_SELECTED_SEARCH_CONDITIONS,
    SET_ADD_SEARCH_CONDITIONS,
    SET_REMOVE_SEARCH_CONDITIONS,
    CRUD_CHANGE_LIST_PARAMS,
} from 'store/actions/listActions';
import {
    SET_SELECTED_SIDEBAR_ITEM,
} from 'store/actions/sidebarActions';

const initialState = [];

export default (previousState = initialState, { type, payload, meta }) => {

    switch (type) {
        // case SET_SELECTED_SEARCH_CONDITIONS:
        //     return payload;
            
        // 검색 조건 추가
        case SET_ADD_SEARCH_CONDITIONS:
            return union(previousState, [payload]);

        // 검색 조건 삭제
        case SET_REMOVE_SEARCH_CONDITIONS:
            return previousState.filter( searchConditionName => searchConditionName !== payload );
        
        // 목록 params가 변경될 때 params에서 검색조건에 해당하는 정보 설정 
        case SET_SELECTED_SEARCH_CONDITIONS:
        case CRUD_CHANGE_LIST_PARAMS:
            const searchConditionsInParams = pickBy(
                payload,
                (value, key) => endsWith(key, 'Cond')
            );
            return Object.keys(searchConditionsInParams);

        // 사이드바에서 메뉴 클릭 시 검색조건 초기화 
        case SET_SELECTED_SIDEBAR_ITEM:
            return initialState;

        default:
            return previousState;
    }
    
};
